<template>
    <v-side-swipe-bar :show="$store.getters.telList.value" @hide="onHide" sbName="telList" :outsideDisabed="true">
        <div class="qpay__header 1" slot="header">
            <p> Статус </p>
        </div>
        <div slot="body">
            <div class="new_grid gap-16">
                <div class="new_grid__row" v-for="value in groupCollection.groups" :key="value.key" v-if="value.isValue">    
                    <div class="new_grid__col">                  
                        <v-tel-group  :value="value"/>
                    </div>      
                </div>
            </div>
            
        </div>
    </v-side-swipe-bar>
</template>

<script>
import vSideSwipeBar from '../../global/SideSwipeBar'
import vTelGroup from './components/telListGroup.vue'
import CollectionTelGroup from './components/telGroup'
import telGroupCollection from './components/telGroupCollection'
import { eventBus } from '@eventBus'



import api from '@api'

export default {
    components: {
        vSideSwipeBar,
        vTelGroup
    },
    data() {
        return {
            isloading: false,
            groupCollection: []
        }
    },
    mounted () {
        this.init()
        this.initSocketActions()
        //console.log('this:',this)
    },
    methods: {
        init() {
            this.getList().then(res=>{
                this.initGroups(res)
            })
        },
        initSocketActions() {
            eventBus.$on('action_update_status', this.updateStatus)
            eventBus.$on('errorConnection', this.init)
        },
        onHide() {
            eventBus.$off('action_update_status', this.updateStatus)
            eventBus.$off('errorConnection', this.init)
            localStorage.setItem('telList', false)
            this.$emit('hide')
        },
        getList() {
            this.loading = true
            return api.communications.operatorList().then(res=>{
                return res
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
        },
        initGroups(groups) {
            this.groupCollection = null;
            this.groupCollection = new telGroupCollection()
            groups.forEach(group => {
                this.groupCollection.push(new CollectionTelGroup(group))
            })
        },
        updateStatus(data) {
            // {
            //     prev_list:'online',
            //     list:'offline',
            //     user_id:'1014',
            //     status: 'test'
            // }

            if(data.prev_list == data.list) { 
                eventBus.$emit('action_update_status_user', data)
                const group = this.groupCollection.getGroupById(data.list)
                group.sort()
                return
            }
            if(!this.groupCollection || !this.groupCollection.groups) return
            const isSwitched = this.groupCollection.switchGroups(data)
            if(!isSwitched) {
                this.init()
            }
        }
    },
}
</script>

